import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import logoSolution from "../assets/imgs/soundbox/Group-156284.png.png";
import bgsolu from "../assets/imgs/soundbox/Group-37736.svg.png";
import header from "../assets/imgs/soundbox/header.png";
import logo from "../assets/svgs/iconLogo.svg";
import api from "../assets/svgs/soundbox/api.svg";
import banking from "../assets/svgs/soundbox/banking.svg";
import bbps from "../assets/svgs/soundbox/bbps.svg";
import card from "../assets/svgs/soundbox/card.svg";
import commer from "../assets/svgs/soundbox/commerial.svg";
import consum from "../assets/svgs/soundbox/consumer.svg";
import cussol from "../assets/svgs/soundbox/cussolution.svg";
import customer from "../assets/svgs/soundbox/customer.svg";
import daily from "../assets/svgs/soundbox/dailyapi.svg";
import doublecard from "../assets/svgs/soundbox/doublecard.svg";
import enach from "../assets/svgs/soundbox/enach.svg";
import finanace from "../assets/svgs/soundbox/fina.svg";
import large from "../assets/svgs/soundbox/large.svg";
import map from "../assets/svgs/soundbox/map.svg";
import perso from "../assets/svgs/soundbox/person.svg";
import plug from "../assets/svgs/soundbox/plug.svg";
import prepaid from "../assets/svgs/soundbox/prepaidcard.svg";
import qr from "../assets/svgs/soundbox/qr.svg";
import sca from "../assets/svgs/soundbox/scalable.svg";
import secure from "../assets/svgs/soundbox/secureser.svg";
import security from "../assets/svgs/soundbox/securityand.svg";
import smart from "../assets/svgs/soundbox/smart.svg";
import soundbox from "../assets/svgs/soundbox/soundbox.svg";
import { LeafButton } from "../components/buttons";
import { FintechItem } from "../components/FintechSolutions";
import { OfferItem, SolutionItem } from "../components/offer";
import { SliderBank, SliderDots } from "../components/slicksdiler";
import Video from "../components/video/Video";

export const HomePage = () => {
  const [showVideo, setShowVideo] = useState(false);
  const handleButtonClick = () => {
    setShowVideo(true); // Khi nhấn nút, set state để hiển thị video
  };
  const handleCloseVideo = () => {
    setShowVideo(false);
  };

  const [count, setCount] = useState(1);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(1);

  const [count3, setCount3] = useState(1);

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref1, entry1] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref2, entry2] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref3, entry3] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref4, entry4] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const [isVisible4, setIsVisible4] = useState(false);
  const entries = useMemo(
    () => [entry, entry1, entry2, entry3, entry4],
    [entry, entry1, entry2, entry3, entry4],
  );

  useEffect(() => {
    const setIsVisibles = [
      setIsVisible,
      setIsVisible1,
      setIsVisible2,
      setIsVisible3,
      setIsVisible4,
    ];
    const isVisibleStates = [
      isVisible,
      isVisible1,
      isVisible2,
      isVisible3,
      isVisible4,
    ];

    entries.forEach((item, index) => {
      if (item && item.isIntersecting && !isVisibleStates[index]) {
        setIsVisibles[index](true); // Đánh dấu đã gặp isIntersecting
      }
    });
  }, [
    entries,
    isVisible,
    isVisible1,
    isVisible2,
    isVisible3,
    isVisible4,
    setIsVisible,
    setIsVisible1,
    setIsVisible2,
    setIsVisible3,
    setIsVisible4,
  ]);

  useEffect(() => {
    const timers = [];

    const startTimer = (setter, interval, limit, increment) => {
      const timer = setInterval(() => {
        setter((prevCount) => {
          if (prevCount < limit) {
            return prevCount + increment;
          } else {
            clearInterval(timer);
            return prevCount;
          }
        });
      }, interval);
      timers.push(timer);
    };

    if (isVisible) {
      startTimer(setCount, 500, 4, 1);
      startTimer(setCount2, 100, 30, 1);
      startTimer(setCount3, 50, 65, 1);
      startTimer(setCount1, 20, 2000, 25);
    }

    return () => {
      timers.forEach((timer) => clearInterval(timer));
    };
  }, [isVisible]);

  const { t, i18n } = useTranslation();

  const userAgent = navigator.userAgent || window.opera;

  // if (/android/i.test(userAgent)) {
  //   return (window.location.href =
  //     "https://play.google.com/store/apps/details?id=la.lcampki.client");
  // }

  // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
  //   return (window.location.href =
  //     "https://apps.apple.com/ao/app/lao-softkey/id6445804009");
  // }

  return (
    <>
      <Helmet>
        <title>{t("header.tabTitle")}</title>
      </Helmet>
      <div className="relative mt-[145px]">
        <div className="relative w-full ">
          <div className="absolute bottom-[400px] right-[0px] sm600:hidden">
            <div className="absolute right-[200px] top-[-20px] h-[400px]  w-[400px] animate-spin rounded-[50%] border border-solid border-blue-200">
              <div className="absolute  right-[200px] top-[-7px]  h-[14px]  w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
            </div>
            <div className=" absolute right-[240px]  top-[16px]  h-[320px]  w-[320px] rounded-[50%] border border-solid border-blue-200"></div>
            <div className=" absolute right-[280px] top-[52px] h-[240px] w-[240px] animate-spin rounded-[50%] border border-solid border-blue-200">
              <div className="absolute  right-[200px] top-[30px]  h-[14px]  w-[14px] rounded-[50%] bg-[#565ADD]"></div>
            </div>
            <div className=" absolute right-[320px] top-[90px] h-[160px] w-[160px] rounded-[50%] border border-solid border-blue-200"></div>
          </div>

          <div className="absolute left-[640px] sm:hidden">
            <div className="absolute right-[200px] top-[-20px] h-[400px]  w-[400px] animate-spin rounded-[50%] border border-solid border-blue-200">
              <div className="absolute  right-[200px] top-[-7px]  h-[14px]  w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
            </div>
            <div className=" absolute right-[240px]  top-[16px]  h-[320px]  w-[320px] rounded-[50%] border border-solid border-blue-200"></div>
            <div className=" absolute right-[280px] top-[52px] h-[240px] w-[240px] animate-spin rounded-[50%] border border-solid border-blue-200">
              <div className="absolute  right-[200px] top-[30px]  h-[14px]  w-[14px] rounded-[50%] bg-[#565ADD]"></div>
            </div>
            <div className=" absolute right-[320px] top-[90px] h-[160px] w-[160px] rounded-[50%] border border-solid border-blue-200"></div>
          </div>

          <div
            ref={ref1}
            className="absolute left-[40%] top-[450px] h-[42px] w-[39px] animate-movesquare-slow rounded-[24px] bg-[#565ADD]"
          ></div>

          <div className="relative mx-auto flex max-w-[1280px] flex-col items-center px-4 py-[44px] mothaibaysaimin:px-8">
            <div
              className={`flex  items-center gap-[10px] lgmaxmin:flex-col  `}
            >
              <div
                className={`flex max-w-[573px] animate-fadeInLeft flex-col gap-[20px] lgmaxmin:max-w-none `}
              >
                <h1 className="max-w-[573px] text-[64px] font-bold leading-[82px] text-[--color-text] lgmaxmin:w-full lgmaxmin:max-w-none">
                  {t("soundbox.header")}
                </h1>
                <p className=" text-[18px] font-bold leading-[46px] text-[--color-hover]">
                  {t("soundbox.built")}
                </p>
                <p className="text-4 max-w-[487px] font-semibold leading-[180%] text-[--color-title] lgmaxmin:w-full lgmaxmin:max-w-none">
                  {t("soundbox.unlock")}
                </p>
                <div>
                  <LeafButton
                    title={t("soundbox.getstart")}
                    style={{ marginTop: "16px" }}
                  />
                </div>
              </div>
              <div className={` relative lgmaxmin:mt-[60px] `}>
                <div></div>
                <div
                  className={` absolute left-[50px] top-0 h-[500px] w-[500px] animate-fadeInUp animate-spin2 rounded-[500px] border-[0.765px] border-dashed border-[--color-hover] sm600:left-0 sm600:h-[150px] sm600:w-[150px] sm600:rounded-[350px]  ${
                    isVisible1 ? "animate-fadeInUp" : null
                  }`}
                ></div>

                <div
                  className={`absolute left-[80px] top-[20px] h-[500px] w-[500px] animate-fadeInUp rounded-[500px]  bg-[--color-hover] sm600:left-0 sm600:h-[350px] sm600:w-[350px]   sm600:rounded-[350px] ${
                    isVisible1 ? "animate-fadeInUp" : null
                  }`}
                ></div>

                <div
                  className={`absolute left-[30px] top-[22%] h-[80px] w-[80px] animate-fadeInOut-50 rounded-[50px] bg-white p-[20px] shadow-item-home sm600:left-[-30px] sm600:top-[30%] ${
                    isVisible1 ? "animate-fadeInOut-50" : null
                  }`}
                >
                  <img
                    className={`animate-fadeInOut-50img ${
                      isVisible1 ? "animate-fadeInOut-50img" : null
                    }`}
                    src={smart}
                    alt=""
                  />
                </div>

                <div
                  className={`animate-fadeInOut50 ${
                    isVisible1 ? "animate-fadeInOut50" : null
                  } z-2 absolute left-[30px] top-[52%] h-[80px] w-[80px]  rounded-[50px] bg-white p-[20px] shadow-item-home sm600:left-[-30px] sm600:top-[70%]`}
                  style={{ zIndex: 2 }}
                >
                  <img
                    className={`animate-fadeInOut50img ${
                      isVisible1 ? "animate-fadeInOut50img" : null
                    }`}
                    src={card}
                    alt=""
                  />
                </div>

                <div
                  className={`animate-fadeInEnter50 ${
                    isVisible1 ? "animate-fadeInEnter50" : null
                  } z-2 absolute  bottom-[68px] right-[97px] h-[80px]  w-[80px] rounded-[50px] bg-white p-[20px] shadow-item-home sm600:right-[-8px]`}
                  style={{ zIndex: 2 }}
                >
                  <img
                    className={`animate-fadeInEnter50img ${
                      isVisible1 ? "animate-fadeInEnter50img" : null
                    }`}
                    src={api}
                    alt=""
                  />
                </div>

                <div
                  className={`animate-fadeInOut-0 ${
                    isVisible1 ? "animate-fadeInOut-0" : null
                  } z-2 absolute right-[402px] top-[-27px] h-[80px]  w-[80px] rounded-[50px]  bg-white p-[20px] shadow-item-home sm600:left-[60px]`}
                  style={{ zIndex: 2 }}
                >
                  <img
                    className={`animate-fadeInOut-0img ${
                      isVisible1 ? "animate-fadeInOut-0img" : null
                    } `}
                    src={doublecard}
                    alt=""
                  />
                </div>

                <div
                  className={`animate-fadeInEnter-0 ${
                    isVisible1 ? "animate-fadeInEnter-0" : null
                  }  z-2 absolute right-[145px] top-[9px] h-[80px]  w-[80px] rounded-[50px] bg-white  p-[20px] shadow-item-home sm:left-[256px]`}
                  style={{ zIndex: 2 }}
                >
                  <img
                    className={`animate-fadeInEnter-0img ${
                      isVisible1 ? "animate-fadeInEnter-0img" : null
                    }`}
                    src={qr}
                    alt=""
                  />
                </div>

                <div
                  className={`animate-fadeInEnter-50 ${
                    isVisible1 ? "animate-fadeInEnter-50" : null
                  } z-2 absolute right-[39px] top-[178px] h-[80px]  w-[80px] rounded-[50px] bg-white p-[20px]  shadow-item-home sm600:top-[256px]`}
                  style={{ zIndex: 2 }}
                >
                  <img
                    className={`animate-fadeInEnter-50img ${
                      isVisible1 ? "animate-fadeInEnter-50img" : null
                    }`}
                    src={card}
                    alt=""
                  />
                </div>

                <img
                  className={`z-1 relative animate-fadeInUp sm600:w-[350px] ${
                    isVisible1 ? "animate-fadeInUp" : null
                  }`}
                  style={{ zIndex: 1 }}
                  src={header}
                  alt=""
                />
              </div>
            </div>
            <div
              ref={ref}
              className={`w-[1110px] ${
                i18n.language === "en" ? "" : "mt-[52px]"
              } mx-[100px] h-[115px] rounded-[20px] bg-white py-[25px] shadow-border-home sm:h-auto sm:w-full  lg:mx-0  lg:w-[840px] mothaibaysai:mx-0 mothaibaysai:mt-[70px] sm600:mt-[140px]`}
            >
              <div className="flex items-center justify-between sm:flex-col sm:items-start sm:gap-[25px]">
                <div className="ml-[10px] flex items-center">
                  <img className="px-[14px] " src={daily} alt="" />
                  <div>
                    <p className="text-[20px] font-bold text-[--color-title]">
                      <span>{count}</span>
                      L+
                    </p>
                    <p className="text-[14px] text-[--color-title]">
                      {t("soundbox.daily")}
                    </p>
                  </div>
                </div>
                <div className="ml-[10px] flex items-center">
                  <img className="px-[14px] " src={daily} alt="" />
                  <div>
                    <p className="text-[20px] font-bold text-[--color-title]">
                      <span>{count1}</span>+
                    </p>
                    <p className="text-[14px] text-[--color-title]">
                      {t("soundbox.b2b")}
                    </p>
                  </div>
                </div>
                <div className="ml-[10px] flex items-center">
                  <img className="px-[14px] " src={daily} alt="" />
                  <div>
                    <p className="text-[20px] font-bold text-[--color-title]">
                      <span>{count2}</span>+
                    </p>
                    <p className="text-[14px] text-[--color-title]">
                      {t("soundbox.indirect")}
                    </p>
                  </div>
                </div>
                <div className="mr-[10px] flex items-center sm:ml-[10px]">
                  <img className="px-[14px] " src={daily} alt="" />
                  <div>
                    <p className="text-[20px] font-bold text-[--color-title]">
                      <span>{count3}</span>
                      M+
                    </p>
                    <p className="text-[14px] text-[--color-title]">
                      {t("soundbox.customer")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref={ref2}>
          <div
            className={`${
              isVisible2 ? "animate-fadeInUp" : null
            } relative mx-auto max-w-[1280px] bg-white px-4 pb-[50px] pt-[0px]`}
          >
            <img
              className=" absolute left-[20%] top-[8%] lg:left-[15%] lgmax:left-0 mothaibaysaimin:left-0 "
              src={map}
              alt=""
            />
            <div className="relative flex flex-col items-center">
              {}
              <h2
                className={` ${
                  i18n.language === "en" ? "max-w-[480px]" : "max-w-[800px]"
                } pb-[20px] text-center text-[36px] font-bold leading-[46px] text-[--color-title]`}
              >
                {t("soundbox.welcome")}
              </h2>
              <img className="h-[150px] w-[150px]" src={logo} alt="" />
              <p className="text-4 mt-[20px] max-w-[780px] text-center font-normal text-[--color-title]">
                {t("soundbox.with")}
              </p>
              <LeafButton
                title={t("soundbox.readmore")}
                style={{ marginTop: "20px" }}
              />
            </div>
          </div>
        </div>

        <div
          ref={ref3}
          className="rounded-tr-[200px] bg-[#EFF0FF] lgmax:rounded-tl-[50px] lgmax:rounded-tr-[50px]"
        >
          <div className="mx-auto  max-w-[1300px] px-4 md:px-[50px]">
            <div className="flex flex-col items-center gap-[20px]">
              <div className={`${isVisible3 ? "animate-fadeInRight" : null}`}>
                <h2 className="max-w-[850px]  text-center text-[36px] font-bold leading-[46px] text-[--color-title]">
                  {t("soundbox.let")}{" "}
                  <span className="whitespace-nowrap text-[--color-hover]">
                    {" "}
                    {t("soundbox.offer")}{" "}
                  </span>
                </h2>
                <p className="text-4 mt-[20px] max-w-[780px] text-center font-normal  text-[--color-text]">
                  {t("soundbox.trustpaydes")}
                </p>
              </div>

              {isVisible3 ? (
                <div className="flex flex-wrap  justify-center">
                  <OfferItem
                    image={api}
                    titleheader={t("soundbox.api")}
                    checkAni={true}
                  />
                  <OfferItem
                    image={bbps}
                    titleheader={t("soundbox.bbps")}
                    checkAni={true}
                    animation={"200ms"}
                  />
                  <OfferItem
                    image={qr}
                    titleheader={t("soundbox.upi")}
                    checkAni={true}
                  />
                  <OfferItem
                    image={enach}
                    titleheader={t("soundbox.enach")}
                    checkAni={true}
                    animation={"400ms"}
                  />

                  <OfferItem
                    image={soundbox}
                    titleheader={t("soundbox.sound")}
                    checkAni={true}
                    animation={"500ms"}
                  />
                  <OfferItem
                    image={card}
                    titleheader={t("soundbox.ekyc")}
                    checkAni={true}
                  />
                  <OfferItem
                    image={customer}
                    titleheader={t("soundbox.cus")}
                    checkAni={true}
                    animation={"200ms"}
                  />
                  <OfferItem
                    image={prepaid}
                    titleheader={t("soundbox.prepaid")}
                    checkAni={true}
                    animation={"300ms"}
                  />
                </div>
              ) : (
                <div className="flex flex-wrap  justify-center">
                  <OfferItem image={api} titleheader={t("soundbox.api")} />
                  <OfferItem image={bbps} titleheader={t("soundbox.bbps")} />
                  <OfferItem image={qr} titleheader={t("soundbox.upi")} />
                  <OfferItem image={enach} titleheader={t("soundbox.enach")} />

                  <OfferItem
                    image={soundbox}
                    titleheader={t("soundbox.sound")}
                  />
                  <OfferItem image={card} titleheader={t("soundbox.ekyc")} />
                  <OfferItem image={customer} titleheader={t("soundbox.cus")} />
                  <OfferItem
                    image={prepaid}
                    titleheader={t("soundbox.prepaid")}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="mx-auto  hidden max-w-[1300px] px-4 md:px-[50px]">
          <div className="relative">
            <img
              decoding="async"
              width="1133"
              height="355"
              src="https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1.png"
              data-src=""
              className="attachment-full wp-image-4852 lazyDone size-full"
              alt=""
              srcSet="https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1.png 1133w, https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1-300x94.png 300w, https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1-1024x321.png 1024w, https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1-768x241.png 768w, https://www.fidypay.com/wp-content/uploads/2023/07/FidyPay-thumbnail-1-600x188.png 600w"
              sizes="(max-width: 1133px) 100vw, 1133px"
            />
            <div
              className="absolute left-[50%] top-[50%] h-[134px] w-[134px] -translate-x-1/2 -translate-y-1/2 rounded-[134px] bg-[#ffffff24] "
              style={{ zIndex: 2 }}
            >
              <span className="inline-block pb-[45px] pl-[42px] pr-[50px] pt-[30px] text-[45px] hover:scale-x-[1.1] hover:scale-y-[1.1]">
                <PlayCircleOutlineIcon
                  sx={{ fontSize: 56, color: "#E53935" }}
                  onClick={handleButtonClick}
                />
              </span>
            </div>
            {showVideo && (
              <Video
                videoId="6Zt1I7Z33Pg"
                showVideo={showVideo}
                onClose={handleCloseVideo}
              />
            )}
          </div>
        </div>

        <div ref={ref4} className="bg-[#EFF0FF] ">
          <div
            className={`${
              isVisible4 ? "animate-fadeInUp" : ""
            } mx-auto max-w-[1400px] flex-col gap-[20px] md:px-[50px] py-[50px] px-4`}
          >
            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {t("soundbox.streamline")}{" "}
              <span className="text-[--color-hover]">
                {t("soundbox.bankingapi")}{" "}
              </span>
            </h1>
            <p className="text-4 mt-[20px] max-w-[1220px] text-center text-[--color-text]">
              {t("soundbox.even")}
            </p>
            <SliderDots />
          </div>
        </div>

        <div className="bg-white">
          <div className="mx-auto max-w-[1280px] px-4 py-[50px]">
            <div className="flex items-center lgmax:flex-col lgmax:items-center lgmax:gap-[60px]">
              <img
                className="h-[600px]  sm600:h-[400px]"
                src={logoSolution}
                alt=""
              />
              <div className="max-w-[768px]">
                {i18n.language === "en" ? (
                  <h1 className="max-w-[1240px]  text-[36px] font-bold text-[--color-title]">
                    {t("soundbox.immediate")}{" "}
                    <span className="text-[--color-hover]">
                      {t("soundbox.solution")}{" "}
                    </span>{" "}
                    {t("soundbox.for")}{" "}
                  </h1>
                ) : (
                  <h1 className="max-w-[1240px]  text-[36px] font-bold text-[--color-title]">
                    {" "}
                    <span className="text-[--color-hover]">
                      {t("soundbox.immediate")}{" "}
                    </span>{" "}
                    {t("soundbox.solution")}{" "}
                  </h1>
                )}

                <p className="text-4 mt-[20px] border-b border-b-[#707070] pb-[20px] leading-[22px] text-[--color-text]">
                  {t("soundbox.we")}
                </p>
                <div className="mt-[20px] flex flex-col gap-[10px] ">
                  <div className="flex gap-[20px] sm:flex-col sm:gap-[40px] ">
                    <div className="sm:mt-[20px]">
                      <SolutionItem
                        image={plug}
                        titleheader={t("soundbox.plug")}
                        title={t("soundbox.plugdes")}
                      />
                    </div>
                    <SolutionItem
                      image={security}
                      titleheader={t("soundbox.security")}
                      title={t("soundbox.securitydes")}
                    />
                  </div>
                  <div className="mt-[10px] flex gap-[20px]  sm:flex-col sm:gap-[40px]">
                    <div className="sm:mt-[20px]">
                      <SolutionItem
                        image={large}
                        titleheader={t("soundbox.large")}
                        title={t("soundbox.largedes")}
                      />
                    </div>

                    <SolutionItem
                      image={plug}
                      titleheader={t("soundbox.reduced")}
                      title={t("soundbox.reduceddes")}
                    />
                  </div>
                </div>
                <LeafButton
                  title={t("soundbox.apido")}
                  style={{ marginTop: "40px" }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-tl-[200px] rounded-tr-[200px] bg-[#D1D1F7]  bg-opacity-[0.73] lgmax:rounded-tl-[50px] lgmax:rounded-tr-[50px]">
          <div className="flex flex-col items-center pt-[70px] px-4">
            <h1
              className={`${
                i18n.language === "en" ? " max-w-[700px]" : "max-w-[900px]"
              } text-center text-[36px] font-bold text-[--color-title]`}
            >
              {t("soundbox.leve")}{" "}
              <span className="text-[--color-hover]">
                {t("soundbox.potential")}{" "}
              </span>
              {t("soundbox.of")}
            </h1>
            <p className="text-4 mb-[20px] mt-[20px] max-w-[1220px] text-center text-[--color-text]">
              {t("soundbox.as")}
            </p>
          </div>
          <div className="flex sm:flex-col">
            <div
              className={`imagePo1 group relative flex-1 px-[10px] pb-[30px] sm:w-[100%]`}
            >
              <div className="absolute bottom-0 left-0 right-0 top-0 bg-[#2B1C50] bg-opacity-[0.7]"></div>
              <div className="relative mt-[60px] ">
                <div className="flex flex-col items-center justify-center gap-[8px]">
                  <img
                    className="w-[97px] group-hover:animate-hover"
                    src={banking}
                    alt=""
                  />
                  <p className="text-center text-[24px]  font-bold text-white">
                    {t("soundbox.banking")}
                  </p>
                  <p className="max-w-[364px] text-center text-[15px] font-normal text-white">
                    {t("soundbox.bankingdes")}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`imagePo2 group relative  flex-1 px-[10px] pb-[30px] sm:w-[100%]`}
            >
              <div className="absolute bottom-0 left-0 right-0 top-0 bg-[#2B1C50] bg-opacity-[0.7]"></div>
              <div className="relative mt-[60px] ">
                <div className="flex flex-col items-center justify-center gap-[8px]">
                  <img
                    className="w-[97px] group-hover:animate-hover"
                    src={consum}
                    alt=""
                  />
                  <p className="text-center  text-[24px]  font-bold text-white">
                    {t("soundbox.cusument")}
                  </p>
                  <p className="max-w-[364px] text-center text-[15px] font-normal text-white">
                    {t("soundbox.cusumentdes")}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`imagePo3 group relative  flex-1 px-[10px] pb-[30px] sm:w-[100%]`}
            >
              <div className="absolute bottom-0 left-0 right-0 top-0 bg-[#2B1C50] bg-opacity-[0.7]"></div>
              <div className="relative mt-[60px] ">
                <div className="flex flex-col items-center justify-center gap-[8px]">
                  <img
                    className="w-[97px] group-hover:animate-hover"
                    src={commer}
                    alt=""
                  />
                  <p className="text-center text-[24px]   font-bold text-white">
                    {t("soundbox.commer")}
                  </p>
                  <p className="max-w-[364px] text-center text-[15px] font-normal text-white">
                    {t("soundbox.commerdes")}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`imagePo4 group relative flex-1 px-[10px] pb-[30px] sm:w-[100%]`}
            >
              <div className="absolute bottom-0 left-0 right-0 top-0 bg-[#2B1C50] bg-opacity-[0.7]"></div>
              <div className="relative mt-[60px] ">
                <div className="flex flex-col items-center justify-center gap-[8px]">
                  <img
                    className="w-[97px] group-hover:animate-hover"
                    src={finanace}
                    alt=""
                  />
                  <p className="text-center text-[24px] font-bold text-white">
                    {t("soundbox.fianace")}
                  </p>
                  <p className="max-w-[364px] text-center text-[15px] font-normal text-white">
                    {t("soundbox.fianacedes")}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`imagePo5 group relative flex-1 px-[10px] pb-[30px] sm:w-[100%]`}
            >
              <div className="absolute bottom-0 left-0 right-0 top-0 bg-[#2B1C50] bg-opacity-[0.7]"></div>
              <div className="relative mt-[60px] ">
                <div className="flex flex-col items-center justify-center gap-[8px]">
                  <img
                    className="w-[97px] group-hover:animate-hover"
                    src={perso}
                    alt=""
                  />
                  <p className="text-center text-[24px]  font-bold text-white">
                    {t("soundbox.personal")}
                  </p>
                  <p className="max-w-[364px] text-center text-[15px] font-normal text-white">
                    {t("soundbox.personalbardes")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative">
            <img className="absolute bottom-[50px]" src={bgsolu} alt="" />
            <div className="flex flex-col items-center gap-[10px] px-4 pt-[50px]">
              <h1 className="max-w-[1260px] text-center text-[36px] font-bold text-[--color-title]">
                {t("soundbox.choose")}{" "}
                <span className="text-[--color-hover]">
                  {t("soundbox.fintech")}{" "}
                </span>
              </h1>
              <p className="text-4 max-w-[1220px] text-center text-[--color-text] ">
                {t("soundbox.simplici")}
              </p>
              <div className="flex gap-[20px] pb-[200px] sm:flex-col">
                <FintechItem
                  image={sca}
                  titleheader={t("soundbox.scalab")}
                  title={t("soundbox.scalabdes")}
                />
                <FintechItem
                  image={cussol}
                  titleheader={t("soundbox.custosol")}
                  title={t("soundbox.custosoldes")}
                />
                <FintechItem
                  image={secure}
                  titleheader={t("soundbox.secure")}
                  title={t("soundbox.securedes")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="relative bg-white pb-[90px] ">
          <div className="relative  mx-auto  max-w-[1440px] px-4 pb-[50px] pt-[60px] ">
            <div className="relative flex  flex-col items-center">
              <h1
                className={`max-w-[1440px] ${
                  i18n.language === "en" ? "px-[300px]" : "px-[100px]"
                }  text-center text-[36px] font-bold text-[--color-title] mothaibaysai:p-[0]`}
              >
                {t("soundbox.here")}{" "}
                <span className="whitespace-nowrap text-[--color-hover]">
                  {t("soundbox.trustpay")}{" "}
                </span>
              </h1>
              <p className="text-4 mt-[10px] max-w-[1220px] text-center text-[--color-text]">
                {t("soundbox.inthe")}
              </p>
            </div>

            {/* TODO: Temp hidden */}
            {/* <SliderOne /> */}
            {/* <div className=" sm absolute bottom-[-42px] left-[20px] right-[20px] h-[630px] max-w-[1400px] rounded-[50px] bg-[#D1D1F7] sm600:h-[500px] sm490:h-[950px]"></div> */}
            <div className="relative mt-[40px] rounded-[50px] bg-[#D1D1F7] p-10 pb-28">
              {i18n.language === "en" ? (
                <h1 className="max-w-[1440px]  text-center text-[36px] font-bold text-[--color-title]">
                  {t("soundbox.our")}{" "}
                  <span className="text-[--color-hover]">
                    {t("soundbox.panner")}{" "}
                  </span>
                </h1>
              ) : (
                <h1 className="max-w-[1440px]  text-center text-[36px] font-bold text-[--color-title]">
                  {t("soundbox.panner")}{" "}
                  <span className="text-[--color-hover]">
                    {t("soundbox.our")}{" "}
                  </span>
                </h1>
              )}
              <div className="pl-[60px] pr-[20px] sm:px-[20px]  sm:pl-[48px] sm490:pl-[20px]">
                <SliderBank />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
